export const CIVIC_CANISTER_BACKEND_ID = '73ncn-4qaaa-aaaag-alddq-cai';
export const CIVIC_DERIVATION_ORIGIN = `https://${CIVIC_CANISTER_BACKEND_ID}.icp0.io`;
export const CIVIC_ISSUER_DEV = '7cuxk-v4pfh-zmhcj-tkydp-ab2nb-tova3-v4l4f-fhwpy-v4xlp-6da7m-kqe';
export const CIVIC_ISSUER_PROD = 'zxdjc-hqniq-yqefw-vpoyk-5soka-o2riz-fdw6l-5ajan-s3sln-gge7o-qqe';
